<template>
  <div class="bank-footer">
    <a class="link-to-bank" :href="source.links.login" target="_blank">
      <img :src="require(`@/assets/bank-logos/${source.logoFile}`)"/>
    </a>
  </div>
</template>

<script>

export default {
  name: 'BankFooter',
  props: {
    source: {
      type: Object,
      required: true,
    },
  },
};

</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../scss/mixins';

  .bank-footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 68px;
    padding: 0 30px;
    border-top: solid 1px $riseup_gray_0;

    .link-to-bank {
      > img {
        height: 40px;
      }
    }
  }

</style>
